export default "__VITE_ASSET__20656b4b__"